export default class InvalidNotificationException extends Error {}
